module.exports = __webpack_public_path__ + "img/slide13.2724b5c7.png";